import angular from 'angular';
import { SavedSearchesService } from './Service/SavedSearchesService';
import { savedSearchesRecentComponent } from './recent/savedSearchesRecentComponent';

angular
	.module('sh.savedSearches', ['sh.api', 'sh.filterMessage', 'sh.fineTunePosts'])
	.service('SavedSearches', SavedSearchesService)
	.component('shSavedSearchesRecent', savedSearchesRecentComponent());
